import { Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import React from 'react'

import PageHeader from '../helper/PageHeader'
import styles from '../styles'

import { useHistory } from 'react-router-dom';

const permissionsMap = [
    { value: "RoleAdmin", title: "Manage User Permissions", detail: "Manage user roles" },
    { value: "UserAdmin", title: "Manage Users", detail: "Manage user profiles, reset user's passwords, view profile change logs." },
    { value: "OnlineTrainingAdmin", title: "Manage online training records", detail: "View all online training reports - student module progress and tests, purchases and coupon reports.  Disregard/delete tests and enter test scores from paper tests (Note: new system should not allow deleting tests but should allow transferring them to different account)" },
    { value: "OnlineTrainingEditor", title: "Manage online training settings", detail: "Manage online training courses general information / settings" },
    { value: "ClassroomTrainingAdmin", title: "Manage Classroom Option Lists", detail: "Manage the option lists used in classroom training including location template, contact template, regions, organization, category." },
    { value: "ClassroomTrainingManager", title: "Manage classes", detail: "Edit classes created by other users" },
    { value: "ProgramCoordinator", title: "Approve classes", detail: "Approve (publish) classes added late or with higher cost" },
    { value: "TrainingCouponAdmin", title: "Manage user purchases", detail: "Create free coupons [new system - add free credit & also remove credit or training after or account transfer]" }, //obsolete
    { value: "InstructorAdministrator", title: "Manage instructors", detail: "Add/Edit Instructors [+ for new system Add/Edit Training provider organizations (not well defined yet)]" },
]

const AdminRoles = props => {

    const history = useHistory()

    const handleClick = role => {
        console.log(role)
        history.push('/administration/roles/'+role)
    }

    return (
        <>
            <PageHeader
                title={"Roles Management"}
            />

            {/* With cards */}
            {/* <Grid container spacing={3}>
                {permissionsMap.map((perm) =>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                        <MediaCard title={perm.title} detail={perm.detail} onClick={handleClick} value={perm.value} />
                    </Grid>
                )}
            </Grid> */}

            {permissionsMap.map((perm) =>
                <div key={perm.value}>
                    <p><span style={{ fontWeight: 'bold' }}>{perm.title}</span><span>{" - " + perm.detail}</span></p>
                    <Button variant="outlined" color="primary" className={[].join(' ')} onClick={()=>handleClick(perm.value)} >Users</Button>
                    <br />
                    <br />
                </div>
            )}

        </>
    )
}



export default withStyles(styles, { withTheme: true })(AdminRoles)

// cards (from material ui), currently unused

// const useStyles = makeStyles({
//     root: {
//         maxWidth: 345,
//     },
//     content: {
//         height: 250,
//     },
// });

// function MediaCard(props) {
//     const classes = useStyles();

//     return (
//         <Card className={classes.root}>
//             <CardContent className={classes.content}>
//                 <Typography gutterBottom variant="h5" component="h2" className={classes.title}>
//                     {props.title}
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary" component="p">
//                     {props.detail}
//                 </Typography>
//             </CardContent>
//             <CardActions>
//                 <Button variant="outlined" size="medium" color="primary" onClick={() => props.onClick(props.value)}>
//                     Users
//                 </Button>
//             </CardActions>
//         </Card>
//     );
// }



// const useStyles = makeStyles((theme) => ({
//     root: {
//         maxWidth: 345,
//     },
//     media: {
//         height: 0,
//         paddingTop: '56.25%', // 16:9
//     },
//     expand: {
//         transform: 'rotate(0deg)',
//         marginLeft: 'auto',
//         transition: theme.transitions.create('transform', {
//             duration: theme.transitions.duration.shortest,
//         }),
//     },
//     expandOpen: {
//         transform: 'rotate(180deg)',
//     },
//     avatar: {
//         backgroundColor: red[500],
//     },
// }));



// function ExpandCard(props) {
//     const classes = useStyles();
//     const [expanded, setExpanded] = React.useState(false);

//     const handleExpandClick = () => {
//         setExpanded(!expanded);
//     };

//     return (
//         <Card className={classes.root}>
//             <CardHeader
//                 title={props.title}
//             />
//             <CardContent>
//                 <Typography variant="body2" color="textSecondary" component="p">
//                     {props.detail.substring(0, 100) + "..."}
//                 </Typography>
//                 <IconButton
//                     className={clsx(classes.expand, {
//                         [classes.expandOpen]: expanded,
//                     })}
//                     onClick={handleExpandClick}
//                     aria-expanded={expanded}
//                     aria-label="show more"
//                 >
//                     <ExpandMoreIcon />
//                 </IconButton>
//             </CardContent>
//             <CardActions disableSpacing>
//                 <Button variant="outlined" size="medium" color="primary" onClick={() => props.onClick(props.value)}>
//                     Users
//                 </Button>

//             </CardActions>
//             <Collapse in={expanded} timeout="auto" unmountOnExit>
//                 <CardContent>
//                     <Typography paragraph>Details</Typography>
//                     <Typography paragraph>
//                         {props.detail}
//                     </Typography>
//                 </CardContent>
//             </Collapse>
//         </Card>
//     );
// }

